import React from 'react';

import schemaResolver from '../../../../state/resolvers/schema/category-breadcrumbs';

import Meta from '../../../../containers/Meta';

const getUrlForPath = (path) => `${WEB_ROOT}/${path}`;

const inflateHrefLang = (hrefLang) =>
  hrefLang.map((hl) => ({
    ...hl,
    href: getUrlForPath(hl.href),
    rel: 'alternate',
  }));

const getTitle = (title, page) => {
  if (!page || page === 1) {
    return title;
  }

  return `${title} (Page ${page})`;
};

const getNextPrevLinks = (props) => {
  const {
    page,
    totalResults,
    resultsPerPage,
    router: { location },
  } = props;
  const { pathname } = location;

  const totalPages = Math.ceil(totalResults / resultsPerPage);

  if (totalPages === 1) {
    return [];
  }

  const links = [];
  if (page < totalPages) {
    links.push({ rel: 'next', href: `${pathname}?page=${page + 1}` });
  }

  if (page > 1) {
    const prevPage = page - 1;
    const prevPagePath =
      prevPage === 1 ? pathname : `${pathname}?page=${prevPage}`;
    links.push({ rel: 'prev', href: prevPagePath });
  }

  return links;
};

const CategoryMeta = (props) => {
  const { categoryData, page } = props;

  // Cannot render without required params.
  if (!categoryData) return null;

  const {
    content: { meta: { title, description, hrefLang: rawHrefLang } = {} } = {},
    path,
  } = categoryData;

  const hrefLang = inflateHrefLang(rawHrefLang);

  const componentProps = {
    title: getTitle(title, page),
    canonical: getUrlForPath(path),
    description,
    hrefLang,
    useTitleTemplate: false,
    socialImage: categoryData.image,
    schemata: [schemaResolver(categoryData)],
    pagination: getNextPrevLinks(props),
  };

  return <Meta {...componentProps} />;
};

CategoryMeta.propTypes = {};

CategoryMeta.defaultProps = {};

export default CategoryMeta;
